import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import * as AssetUtils from '../../../../utils/asset';
import { sanitizeHTML } from '../../../../utils/string';
import { ItemCTA } from '../item-components';

//  TODO see if ctaLink prop of cta is required
class ItemCTAContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { ctaHeadline, ctaByline, ctaButtonText, ctaDescription, ctaPrice, ctaLink, ctaFeatureAssetRef } =
      this.props.cta;
    const asset =
      !!ctaFeatureAssetRef &&
      AssetUtils.assetFromRef(ctaFeatureAssetRef, this.props.assetUrl, this.props.assetUgcUrl).src;

    return (
      <div className="xCTAContent">
        <div className={clsx('xCTAContentContainer', { xCTAContentContainerHasAsset: !!asset })}>
          <If condition={!!asset}>
            <div className="xMediaContainer xRenderEmbed xAssetImage">
              <img src={asset} alt={ctaHeadline || ctaByline || ctaDescription || 'Content Image'} />
            </div>
          </If>
          <If condition={!!ctaHeadline}>
            <h1 className="xTitle xHeading">{ctaHeadline}</h1>
          </If>
          <If condition={!!ctaByline}>
            <h2 className="xTitle xByline">{ctaByline}</h2>
          </If>
          <If condition={!!ctaDescription}>
            <p className="xCopy xContentBody" dangerouslySetInnerHTML={sanitizeHTML(ctaDescription)} />
          </If>
          <If condition={!!ctaPrice}>
            <p className="xCopy xContentPrice xCTAPrice">{ctaPrice}</p>
          </If>
          <If condition={!!ctaButtonText && !!ctaLink}>
            <ItemCTA href={ctaLink} target="_blank" linkText={ctaButtonText} />
          </If>
        </div>
      </div>
    );
  }
}

ItemCTAContent.propTypes = {
  cta: PropTypes.shape({
    ctaHeadline:        PropTypes.string,
    ctaByline:          PropTypes.string,
    ctaButtonText:      PropTypes.string,
    ctaDescription:     PropTypes.string,
    ctaLink:            PropTypes.string,
    ctaPrice:           PropTypes.string,
    ctaFeatureAssetRef: PropTypes.string,
  }).isRequired,
};

export default ItemCTAContent;
